module.exports = __webpack_public_path__ + "img/data-view-usage-frequency-active.08063e59.svg";